import controller from './note-comment.controller';
import template from './note-comment.html';

export default {
	template,
	bindings: {
		disabled: '<?ngDisabled',
		comment:  '<ngModel',

		onDelete: '&?',
		onSubmit: '&?',
	},
	controller,
	require:  {
		ngModelCtrl:     'ngModel',
		parent:          '^^?noteComment',
		noteContextCtrl: '^^?noteContext',
		commentsCtrl:    '^^?comments',
	},
};
